import React, { Component } from "react";
import { GiSettingsKnobs } from "react-icons/gi";
import { IoMdArrowDropdown } from "react-icons/io";

class FilterCourse extends Component {
    state = {
        filter_type: [
            { name: "All", id: "1" },
            { name: "GIS", id: "2" },
            { name: "Drone", id: "3" },
            { name: "Remote Sensing", id: "4" },
            { name: "Survey", id: "5" },
            { name: "Event", id: "6" },
            { name: "Webinar", id: "7" },
            { name: "Podcast", id: "8" },
        ],
        // filter_level: [
        //     { name: "Beginner", id: "1" },
        //     { name: "Intermediate", id: "2" },
        //     { name: "Advance", id: "3" },
        //     { name: "Professional", id: "4" },
        //     { name: "Beginner to Intermediate", id: "5" },
        //     { name: "Beginner to Advance", id: "6" },
        //     { name: "Beginner to Professional", id: "7" },
        // ],
        filter_level: [
            { name: "All", id: "1" },
            { name: "Beginner to Intermediate", id: "2" },
            { name: "Beginner to Advance/Professional", id: "3" },
            { name: "Beginner", id: "4" },
            { name: "Intermediate", id: "5" },
            { name: "Advance/Professional", id: "6" }
        ],
        filter_status: [
            { name: "All", id: "1" },
            { name: "Online", id: "2" },
            { name: "Physical", id: "3" },
        ],
        filter_type_name: this.props.filterType || "Type", // Initialize from props
        selectedItem: this.props.filterType || "",
        filter_level_name: this.props.filterLevel || "Level",// Initialize from props
        selectedItems: this.props.filterLevel || "",
        filter_status_name: this.props.filterStatus || "Status",// Initialize from props
        selectedIteme: this.props.filterStatus || "",
    }
    handleSearchItem = (e) => {
        e.preventDefault()
        this.setState({
            filter_type_name: e.target.innerText,
            selectedItem: e.target.innerText,
        })
        this.props.onFilterChange(e.target.innerText, this.state.filter_level_name,this.state.filter_status_name); // Call the callback
        this.handledisplay(e);
    }
    handleSearchItems = (e) => {
        e.preventDefault()
        this.setState({
            filter_level_name: e.target.innerText,
            selectedItems: e.target.innerText,
        })
        this.props.onFilterChange(this.state.filter_type_name, e.target.innerText,this.state.filter_status_name); // Call the callback
        this.handledisplays(e);
    }
    handleSearchIteme = (e) => {
        e.preventDefault()
        this.setState({
            filter_status_name: e.target.innerText,
            selectedIteme: e.target.innerText,
        })
        this.props.onFilterChange(this.state.filter_type_name,this.state.filter_level_name, e.target.innerText,); // Call the callback
        this.handledisplaye(e);
    }
    handledisplay = (e) => {
        e.preventDefault()
        const dropdown = document.getElementById("Filter_type")
        dropdown.style.display = dropdown.style.display === "block" ? "none" : "block";
        const dropdowns = document.getElementById("Filter_level")
        dropdowns.style.display = "none";
        const dropdowne = document.getElementById("Filter_status")
        dropdowne.style.display = "none"

    }
    handledisplays = (e) => {
        e.preventDefault()
        const dropdown = document.getElementById("Filter_level")
        dropdown.style.display = dropdown.style.display === "block" ? "none" : "block";
        const dropdowns = document.getElementById("Filter_type")
        dropdowns.style.display = "none"
        const dropdowne = document.getElementById("Filter_status")
        dropdowne.style.display = "none"
    }
    handledisplaye = (e) => {
        e.preventDefault()
        const dropdown = document.getElementById("Filter_status")
        dropdown.style.display = dropdown.style.display === "block" ? "none" : "block";
        const dropdowns = document.getElementById("Filter_type")
        dropdowns.style.display = "none"
        const dropdowne = document.getElementById("Filter_level")
        dropdowne.style.display = "none"
    }
    handleReset = () => {
        this.setState({
            filter_type_name: "Type",
            selectedItem: "",
            filter_level_name: "Level",
            selectedItems: "",
            filter_status_name: "Status",
            selectedIteme: "",
        });
    };
    render() {
        const filter_types = this.state.filter_type
        const main_type = filter_types.length ?
            filter_types.map(list => {
                return (
                    <li key={list.id}><button className={this.state.selectedItem === list.name ? "active" : "search_item"} onClick={this.handleSearchItem}>{list.name}</button> </li>
                )
            }) : (<li>Reload</li>)

        const filter_levels = this.state.filter_level
        const main_level = filter_levels.length ?
            filter_levels.map(list => {
                return (
                    <li key={list.id}><button className={this.state.selectedItems === list.name ? "active" : "search_item"} onClick={this.handleSearchItems}>{list.name}</button> </li>
                )
            }) : (<li>Reload</li>)
        const filter_statuss = this.state.filter_status
        const main_status = filter_statuss.length ?
            filter_statuss.map(list => {
                return (
                    <li key={list.id}><button className={this.state.selectedIteme === list.name ? "active" : "search_item"} onClick={this.handleSearchIteme}>{list.name}</button> </li>
                )
            }) : (<li>Reload</li>)

        const filter_level_name = this.state.filter_level_name
        const filter_type_name = this.state.filter_type_name
        const filter_status_name = this.state.filter_status_name
        return (
            <nav className="course_filter">
                <button className="writeup filter"><GiSettingsKnobs /> Filter</button>
                <div className="course_filter"><button className="filter" onClick={this.handledisplay}>{filter_type_name} <IoMdArrowDropdown /></button>
                    <div className="filter_dropdown" id="Filter_type">
                        {main_type}
                    </div>
                </div>
                <div className="course_filter"><button className="filter" onClick={this.handledisplays}>{filter_level_name} <IoMdArrowDropdown /></button>
                    <div className="filter_dropdown" id="Filter_level">
                        {main_level}
                    </div>
                </div>
                <div className="course_filter"><button className="filter" onClick={this.handledisplaye}>{filter_status_name} <IoMdArrowDropdown /></button>
                    <div className="filter_dropdown" id="Filter_status">
                        {main_status}
                    </div>
                </div>

            </nav>
        )
    }
}

export default FilterCourse